import axios from 'axios'
import { URL } from '../../../env'
import { EDITOR_TOOLBAR } from './editorToolbar'

export default {
  data: () => ({
    iso_message: null,
    accounting_reply: {},
    progressModel: false,
    customToolbar: EDITOR_TOOLBAR,
  }),
  mounted() {
    axios.get(URL + '/api/get_accounting_reply_data/' + this.$route.params.unique_id).then(resp => {
      this.accounting_reply = resp.data.length > 0 ? resp.data[0] : {}
    })
  },
  methods: {
    async sendNotification() {
      this.progressModel = true
      await axios
        .post(URL + '/api/message_to_accounting', {
          message: this.iso_message,
          syndicate_id: this.accounting_reply.syndicate_id,
          deal_id: this.accounting_reply.deal_id,
          payPercent: this.accounting_reply.pay_percent,
          id: this.accounting_reply.id,
        })
        .then(() => {
          this.progressModel = false
          this.flash('Reply sent to accounting team', 'success', { timeout: 3000 })
          setTimeout(() => {
            window.close()
          }, 3000)
        })
    },
  },
}
